import React, { useEffect, useState, useRef } from "react";
// import PdfViewer from "./PdfViewer";
import { Box, Button, ButtonGroup, Heading, HStack, IconButton, Tooltip, ChakraProvider } from "@chakra-ui/react";
// import { MdWidthFull } from "react-icons/md";
import { ChevronUpIcon, ChevronDownIcon } from "@chakra-ui/icons";
import styles from "./Rawlog.module.css"
import { Resize1, Resize2 } from "./icons";
import Custheme from "../pages/ChakraCustom.js";
// import { Cursor, Gutter } from "ace-builds/src-noconflict/ace.js";
import ace from "react-ace";
// import { useNavigate } from "react-router-dom";

function RawLog(props) {
  const [toggle, setToggle] = useState(true);
  const [data, setData] = useState();
  const logRef = useRef(null);
  // const { hash } = useNavigate();

  useEffect(() => {
    setData(props.data)
  }, [props.data])

  const scrollToTop = () => {
    if (logRef.current) {
      logRef.current.scrollTop = 0;
    }
  };
  const scrollToBottom = () => {
    if (logRef.current) {
      logRef.current.scrollTop = logRef.current.scrollHeight;
    }
  };

  // MARK: Error Log
  const errorLog = () => {
    const errorStat = [];
    const lines = data?.split("\n");

    // const errorLine = [];
    // const lineRegex = /l\.(\d+)/g;
    // const match = "";

    const aceline = (lines, startIndex) => {
      for (let offset = 1; offset <= 10; offset++) {
        const nextLine = lines[startIndex + offset] || "";
        const match = nextLine.match(/l\.(\d+)/);
        if (match) return parseInt(match[1], 10) - 1;
      }
      return startIndex; //back to error line itself
    };
    lines?.forEach((line, i) => {
      if (line.startsWith("!") && line !=="!  ==> Fatal error occurred, no output PDF file produced!") {
        const aceLinemat = aceline(lines, i);
        errorStat.push({ line, lineIndex: aceLinemat });//Array of objects of errorStat
      }
    });

    let render;
    if (errorStat.length > 0) {
      render = errorStat?.map((item) => (
        <div key={item.lineIndex}
          onClick={() => { goToLine(item.lineIndex) }}
          className={styles.errorbox_outer}
          style={{ cursor: "pointer" }}
        >
          <p>{item.line}</p>
        </div>
      ))
    } else {
      render = (<div><p>No error's to show. Please check the Raw log.</p></div>)
    }
    return render;
  }
  const goToLine = (lineNo) => {
    console.log(lineNo);

    if (!props.ace.current.editor) return;
   
    const editor = props.ace.current.editor;
     editor.getSession().removeGutterDecoration(lineNo, styles.myIconGutter);
     editor.getSession().addGutterDecoration(lineNo, styles.myIconGutter);
    editor.scrollToLine(lineNo);
  }


  return (
    <>
      <div className={styles.header}>
        <HStack
          backgroundColor="var(--primary-main)"
          justifyContent="space-between"
          h="48px"
          width="auto"
          zIndex={10}
        >
          <ButtonGroup spacing="1">
            <Tooltip label="Error Log">
              <Button
                onClick={() => {
                  setToggle(true)
                }}
                bg={toggle === true ? "var(--secondary-main)" : ""}
                color="white"
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "var(--primary-main)" }}
              >Error Log</Button>
            </Tooltip>
            <Tooltip label="Raw Log">
              <Button
                onClick={() => {
                  setToggle(false)
                }}
                color="white"
                bg={toggle === false ? "var(--secondary-main)" : ""}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Zoom-Out"
                _hover={{ bg: "var(--secondary-main)" }}
              >Raw Log</Button>
            </Tooltip>
          </ButtonGroup>
          {props.pdfFull ? (
            <Tooltip label="Minimize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                }}
                size="lg"
                bg="var(--secondary-main)"
                aria-label="Resize pdf"
                icon={<Resize2 />}
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          ) : (
            <Tooltip label="Maximize PDF">
              <IconButton
                onClick={() => {
                  props.toggleEditor();
                  // setClientWidth(1);
                }}
                size="lg"
                colorScheme="#f47c0d"
                aria-label="Resize pdf"
                icon={<Resize1 />}
                bg="var(--secondary-main)"
                _hover={{ bg: "var(--primary-main)" }}
              ></IconButton>
            </Tooltip>
          )}
        </HStack>
      </div>


      <div
        ref={logRef}
        className={styles.rawlogoutput}
        style={{
          width: "100%",
          overflowY: "auto",
          height: "calc(90vh - 48px)",
          position: "relative",
        }}
      >
        {props.data !== "" ? (
          toggle ? (
            <div style={{ width: "100%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "93%", textWrap: "wrap" }}>{errorLog()}</p></pre>
            </div>
          ) : (
            <div style={{ width: "85%" }}>
              <pre style={{ width: "100%" }}><p style={{ width: "600px", textWrap: "wrap" }}>{props.data}</p></pre>
            </div>
          )
        ) : (
          <div style={{ height: "100%", alignItems: "center", display: "flex", justifyContent: 'center', paddingTop: "50px" }}>
            <p style={{ textAlign: "center", fontSize: "20px", fontWeight: "500" }}>No Logs to Show</p>
          </div>
        )}

      </div>
      <Box
        width={"6px"}
        position="absolute"
        bottom="5%"
        right="50px"
        zIndex="999"
      >
        <Box display="flex"
          flexDirection="column"
          gap="8px">
          <ChakraProvider theme={Custheme}>
            <Tooltip label="Scroll to top">
              <IconButton
                display={"block"}
                size="sm"
                colorScheme="black"
                aria-label="Scroll to top"
                icon={<ChevronUpIcon />}
                onClick={scrollToTop}
              />
            </Tooltip>

            <Tooltip label="Scroll to bottom">
              <IconButton
                size="sm"
                colorScheme="black"
                aria-label="Scroll to bottom"
                icon={<ChevronDownIcon />}
                onClick={scrollToBottom}
              />
            </Tooltip>
          </ChakraProvider>
        </Box>
      </Box>
    </>
  );
}


export default RawLog;

{/* <Box
              position="fixed"
              bottom="30px"
              right="30px"
              display="flex"
              flexDirection="column"
              gap="8px"
              zIndex="999"
            >
              <Tooltip label="Scroll to top">
                <IconButton
                  size="md"
                  colorScheme="orange"
                  aria-label="Scroll to top"
                  icon={<ChevronUpIcon />}
                  onClick={() => logRef.current?.scrollTo({ top: 0, behavior: "smooth" })}
                />
              </Tooltip>
      
              <Tooltip label="Scroll to bottom">
                <IconButton
                  size="md"
                  colorScheme="orange"
                  aria-label="Scroll to bottom"
                  icon={<ChevronDownIcon />}
                  onClick={() =>
                    logRef.current?.scrollTo({
                      top: logRef.current.scrollHeight,
                      behavior: "smooth",
                    })
                  }
                />
              </Tooltip>
            </Box> */}

//             <Box position={"fixed"} >
//   {props.pdfFull ? (
//     <Tooltip label="Minimize PDF">
//       <IconButton
//         onClick={() => {
//           props.toggleEditor();
//         }}
//         size="lg"
//         bg="var(--primary-main)"
//         aria-label="Resize pdf"
//         icon={<Resize2 />}
//         _hover={{ bg: "var(--secondary-main)" }}
//       ></IconButton>
//     </Tooltip>
//   ) : (
//     <Tooltip label="Maximize PDF">
//       <IconButton
//         onClick={() => {
//           props.toggleEditor();
//           // setClientWidth(1);
//         }}
//         size="lg"
//         colorScheme="#f47c0d"
//         aria-label="Resize pdf"
//         icon={<Resize1 />}
//         bg="var(--primary-main)"
//         _hover={{ bg: "var(--secondary-main)" }}
//       ></IconButton>
//     </Tooltip>
//   )}
// </Box>